var _circle, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBadge1Icon = function SvgBadge1Icon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5053,
    cy: 29.5053,
    r: 24.5053,
    fill: "#302862",
    stroke: "#272054",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_3237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2351 23.1514L24.4931 21.0259H32.4934L37.8371 23.3382L33.1137 25.6506H24.2398L19.2351 23.1514Z",
    fill: "#FF80F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2351 23.1514L15.8179 26.925L22.7513 31.4734L24.2398 25.6506L19.2351 23.1514Z",
    fill: "#CE5BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1138 25.6506L35.3995 31.4734L41.6144 26.7945L37.8371 23.3382L33.1138 25.6506Z",
    fill: "#CE5BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2397 25.6506L33.1471 25.7223L35.3993 31.4734H22.7512L24.2397 25.6506Z",
    fill: "#A54998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3995 31.4734L35.2584 31.7411L29.0754 41.6137L41.6144 26.7946L35.3995 31.4734Z",
    fill: "#A54998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7513 31.4735L29.0754 41.6137L15.8179 26.925L22.7513 31.4735Z",
    fill: "#A54998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3993 31.4734L29.0753 41.6136L22.7512 31.4734H35.3993Z",
    fill: "#CE5BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6257 23.3428C19.9078 23.7416 20.1533 24.1703 20.3895 24.563C21.0363 25.6384 21.4368 26.8296 21.9379 27.9675C22.2564 28.6999 22.4621 29.4746 22.5481 30.2661C22.5933 30.6475 22.6315 31.0555 22.7149 31.4467L22.7507 31.4704L24.24 25.6467L19.6257 23.3428Z",
    fill: "#E065D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6191 22.8563C36.5446 22.889 36.4684 22.918 36.3908 22.9432C35.4993 23.2391 34.5049 23.3169 33.5759 23.4343C32.4615 23.5754 31.3689 23.6891 30.2428 23.6891C28.9118 23.6891 27.5932 23.7653 26.2629 23.6891C24.9327 23.6128 23.5938 23.6761 22.2924 23.416C21.5279 23.2635 20.6083 23.1224 19.8539 22.9013L19.2219 23.1545L24.2399 25.6964H33.113L37.8372 23.3833L36.6191 22.8563Z",
    fill: "#FFA4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1137 25.0916H24.2398L19.8539 22.9012L19.2351 23.1514L24.2398 25.6956L33.1083 25.7223L37.8371 23.3382L37.2308 23.0759L33.1137 25.0916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.235 23.1514L19.0176 23.3908L23.9163 25.8367L22.5151 31.3186L22.7512 31.4734L24.2397 25.6506L19.235 23.1514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5133 31.4361C35.5133 29.592 36.2326 28.0209 37.1421 26.4384C37.5317 25.7612 37.9892 25.1328 38.2557 24.3899C38.5082 23.6852 38.0219 23.4435 37.4086 23.747C36.3526 24.2679 35.3232 24.8002 34.2563 25.3127C33.5549 25.6506 33.2003 25.8062 33.4934 26.6291C33.6944 27.195 33.9664 27.7548 34.2181 28.3069C34.6615 29.2785 35.1813 30.3661 35.5133 31.2897V31.4361Z",
    fill: "#AAE6F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.4941 25.7665L38.0499 23.5365L37.8371 23.3428L33.1138 25.6544L35.3995 31.4772L35.659 31.282L33.4941 25.7665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.328 28.2257C39.0612 26.5295 39.0612 23.7795 37.328 22.0833C35.5948 20.3871 32.7848 20.3871 31.0516 22.0833C29.3184 23.7795 29.3184 26.5295 31.0516 28.2257C32.7848 29.9218 35.5948 29.9218 37.328 28.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.8094 27.9499C37.4825 27.2757 38.2803 25.4018 37.5914 23.7645C36.9025 22.1271 34.9877 21.3463 33.3146 22.0205C31.6415 22.6947 30.8436 24.5686 31.5326 26.206C32.2215 27.8433 34.1363 28.6241 35.8094 27.9499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.5609 22.7869C34.4199 23.7646 34.5609 24.9848 32.7849 25.1374C33.3109 25.3776 33.8985 25.5873 34.2656 26.0693C34.5913 26.4987 34.8571 27.2209 34.9124 27.7471C35.0122 27.1797 34.8773 26.6505 35.2358 26.0693C35.3656 25.855 35.5435 25.6724 35.756 25.5353C35.9685 25.3981 36.2101 25.31 36.4624 25.2777C35.8943 24.9726 35.4003 25.0184 35.0558 24.3541C34.9211 24.1031 34.8092 23.841 34.7215 23.5709C34.6373 23.2986 34.6669 22.8753 34.4877 22.6763L34.5609 22.7869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.9668 32.6973C26.3544 30.7942 25.0921 28.9441 23.1475 28.5649C21.2029 28.1856 19.3123 29.4209 18.9248 31.324C18.5373 33.227 19.7996 35.0772 21.7442 35.4564C23.6888 35.8357 25.5793 34.6004 25.9668 32.6973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.3972 31.8754C25.3972 32.3882 25.2418 32.8896 24.9506 33.316C24.6595 33.7424 24.2457 34.0747 23.7615 34.271C23.2774 34.4673 22.7446 34.5186 22.2306 34.4186C21.7166 34.3185 21.2445 34.0715 20.874 33.7089C20.5034 33.3463 20.2511 32.8842 20.1488 32.3812C20.0466 31.8782 20.099 31.3569 20.2996 30.8831C20.5001 30.4093 20.8397 30.0043 21.2755 29.7194C21.7112 29.4344 22.2235 29.2823 22.7475 29.2823C23.4503 29.2823 24.1242 29.5555 24.6211 30.0418C25.118 30.5281 25.3972 31.1877 25.3972 31.8754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.7466 30.0946C22.6328 30.8832 22.7466 31.8739 21.3096 31.9936C21.7351 32.1881 22.2104 32.3582 22.5074 32.7479C22.7715 33.0949 22.9859 33.6791 23.0311 34.1039C23.109 33.6463 23.003 33.2169 23.2929 32.7486C23.3979 32.5754 23.5417 32.4277 23.7136 32.3168C23.8855 32.206 24.0808 32.1348 24.285 32.1088C23.8259 31.8594 23.4277 31.899 23.1472 31.3614C23.0382 31.1585 22.9478 30.9467 22.8768 30.7284C22.8082 30.5072 22.8323 30.1655 22.685 30.0038L22.7466 30.0946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.0793 31.436C23.4102 31.5619 23.7311 31.7115 24.0394 31.8837C25.3292 32.5968 26.5426 33.7476 27.4746 34.8649C28.3833 35.954 28.981 37.1613 29.2288 38.5501C29.3644 39.3127 29.4431 40.0899 29.5218 40.8601L35.3986 31.436H23.0793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.8467 31.436C30.8467 31.436 26.4436 37.0797 26.5215 36.9668C26.5995 36.8539 33.808 31.4757 33.808 31.4757L30.8467 31.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6377 23.9255L28.08 21.0259H29.2389L22.8197 24.9863L20.6377 23.9255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.8591 25.6537L32.5713 21.0007L33.4675 21.3882L30.2427 25.6697L25.8591 25.6537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_3237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7965,
    height: 20.8036,
    fill: "white",
    transform: "translate(15.8179 20.8108)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadge1Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge-1-icon.3033a0b8.svg";
export { ForwardRef as ReactComponent };